// Periodic Background Sync (Chromium, installed app only). The service worker handles the tag in
// sw.ts; the page registers it.
export const PERIODIC_SYNC_TAG = "liste4000:sync-all";

type PeriodicSyncManager = {
  register: (tag: string, opts: {minInterval: number}) => Promise<void>;
};

export const registerPeriodicSync = async () => {
  if (!("serviceWorker" in navigator)) return;
  const registration = await navigator.serviceWorker.ready;
  const periodicSync = (registration as {periodicSync?: PeriodicSyncManager}).periodicSync;
  if (!periodicSync) return;
  const status = await navigator.permissions
    .query({name: "periodic-background-sync" as PermissionName})
    .catch(() => null);
  if (status?.state !== "granted") return;
  // the browser treats this as a lower bound and usually waits much longer
  await periodicSync.register(PERIODIC_SYNC_TAG, {minInterval: 6 * 60 * 60 * 1000});
};
